import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import type React from "react";
import { createContext, useContext } from "react";
import { api } from "@/elements/components/utils/convex-api";

const DEFAULT_TIMEZONE = "Asia/Dubai";

const TimezoneContext = createContext<string>(DEFAULT_TIMEZONE);

export function TimezoneProvider({ children }: { children: React.ReactNode }) {
  const { data: timezoneIdentifier } = useQuery(
    convexQuery(api.account.timezoneQueries.getTimezoneIdentifier, {}),
  );

  return (
    <TimezoneContext.Provider value={timezoneIdentifier ?? DEFAULT_TIMEZONE}>
      {children}
    </TimezoneContext.Provider>
  );
}

export function useTimezone() {
  return useContext(TimezoneContext);
}
